import { useState } from 'react';
import { ChevronLeft, ChevronRight } from 'lucide-react';

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

const getImageUrl = (photo) => {
  if (!photo) return null;
  const path = photo.storage_path;
  if (!path) return null;
  if (path.startsWith('http://') || path.startsWith('https://')) return path;
  return `${API}/files/${path}`;
};

export const ImageCarousel = ({ photos = [], alt = '', className = '', showCounter = false }) => {
  const [index, setIndex] = useState(0);
  const total = photos.length;

  if (total === 0) {
    return (
      <div className={`w-full h-full bg-paper-2 flex items-center justify-center ${className}`}>
        <span className="caps text-muted">No photos</span>
      </div>
    );
  }

  const goTo = (e, dir) => {
    e.stopPropagation();
    e.preventDefault();
    setIndex((i) => (i + dir + total) % total);
  };

  return (
    <div className={`relative overflow-hidden w-full h-full ${className}`} data-testid="image-carousel">
      <img
        src={getImageUrl(photos[index])}
        alt={alt}
        className="w-full h-full object-cover"
      />
      {total > 1 && (
        <>
          <button
            type="button"
            onClick={(e) => goTo(e, -1)}
            className="absolute left-3 top-1/2 -translate-y-1/2 w-11 h-11 rounded-full flex items-center justify-center bg-white text-black shadow-[0_3px_10px_rgba(0,0,0,0.28)] ring-1 ring-black/10 hover:scale-105 hover:shadow-[0_5px_14px_rgba(0,0,0,0.34)] active:scale-95 transition-all"
            aria-label="Previous photo"
            data-testid="carousel-prev"
          >
            <ChevronLeft className="w-6 h-6" strokeWidth={2.4} />
          </button>
          <button
            type="button"
            onClick={(e) => goTo(e, 1)}
            className="absolute right-3 top-1/2 -translate-y-1/2 w-11 h-11 rounded-full flex items-center justify-center bg-white text-black shadow-[0_3px_10px_rgba(0,0,0,0.28)] ring-1 ring-black/10 hover:scale-105 hover:shadow-[0_5px_14px_rgba(0,0,0,0.34)] active:scale-95 transition-all"
            aria-label="Next photo"
            data-testid="carousel-next"
          >
            <ChevronRight className="w-6 h-6" strokeWidth={2.4} />
          </button>
          <div className="absolute bottom-3 left-1/2 -translate-x-1/2 flex gap-1.5">
            {photos.slice(0, 8).map((_, i) => (
              <button
                key={i}
                type="button"
                onClick={(e) => { e.stopPropagation(); e.preventDefault(); setIndex(i); }}
                className={`h-1.5 rounded-full transition-all ${
                  i === index ? 'bg-white w-5' : 'bg-white/70 w-1.5'
                }`}
                aria-label={`Photo ${i + 1}`}
              />
            ))}
          </div>
          {showCounter && (
            <div className="absolute top-3 right-3 caps bg-black/70 text-white px-2 py-1 text-[10px] rounded-md">
              {index + 1} / {total}
            </div>
          )}
        </>
      )}
    </div>
  );
};

export default ImageCarousel;
